module.exports = vendors_ru_ebecbef76601cf60ed46;